import React, { useEffect } from 'react';
import styles from './Popup.module.css';
import { PopupProps } from './Popup.model';
import { Typography } from '../../common/Typography/Typography';

const Popup: React.FC<PopupProps> = ({ open, onClose, children, title, size = 'm', fullHeight }) => {
  useEffect(() => {
    if (open) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [open]);

  if (!open) return null;

  const handleBackgroundClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleBackgroundClick}>
      <div className={`${styles.popup} ${styles[size]}${fullHeight ? ` ${styles.fullHeight}` : ''}`}>
        {title ? <Typography variant='h4' className={styles.title}>{title}</Typography> : null}
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Popup; 